import React from "react";
import TestPage1 from "./TestPage1";
const TestHome = () => {
  return (
    <div>
      <TestPage1 />
    </div>
  );
};

export default TestHome;
